import "@/integrations/sentry";
import { installGlobalHandler } from "@/integrations/domResilience/globalHandler";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

installGlobalHandler();

const container = document.getElementById("root")!;
const root = createRoot(container);
root.render(<App />);
